import { Version } from 'domains/version'

import { basicApi } from './requester'

export const getVersion = async () => {
  return basicApi.get<Version>('/version').then((response) => response.data)
}
